module.exports = __webpack_public_path__ + "assets/ea551887a0b76faf02e9e5f5c3933c67.png";